import { AccessResult } from "utils/access";
import DiscardRunButton from "components/Run/elements/DiscardRunButton";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";

import { RunHistoryEntryType } from "../../types";

type QueuedEntryProps = {
  timestamp: number;
  until: number | null;
  showDiscardButton: boolean;
  canDiscard: AccessResult;
  stackId: string;
  runId: string;
  runQueryToRefetch: string;
};

const QueuedEntry = ({
  timestamp,
  until,
  showDiscardButton,
  canDiscard,
  stackId,
  runId,
  runQueryToRefetch,
}: QueuedEntryProps) => {
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.Queued} timestamp={timestamp} until={until}>
      {showDiscardButton && (
        <DiscardRunButton
          stackId={stackId}
          runId={runId}
          runQueryToRefetch={runQueryToRefetch}
          canDiscard={canDiscard}
        />
      )}
    </HistoryEntryWrapper>
  );
};

export default QueuedEntry;
